import { render, staticRenderFns } from "./watchlistGridCards.vue?vue&type=template&id=f3c10048&scoped=true&"
import script from "./watchlistGridCards.vue?vue&type=script&lang=js&"
export * from "./watchlistGridCards.vue?vue&type=script&lang=js&"
import style0 from "./watchlistGridCards.vue?vue&type=style&index=0&id=f3c10048&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f3c10048",
  null
  
)

export default component.exports